import React from 'react';

const AboutEnculture = () => {
  return (
    <section className="about-enculture">
      <div className="container">
        <h2 className="section-title">About Enculture Build Labs</h2>
        <div className="about-content">
          <p>Enculture Build Labs are practical, hands-on learning experiences that help HR leaders bridge the gap between strategy and execution.</p>
          <p>Each lab explores how emerging technologies like AI can simplify work, strengthen insights, and help HR lead intelligently.</p>
        </div>
      </div>
    </section>
  );
};

export default AboutEnculture;
